/* ZED: pause the homepage hero animation while it is off screen.
   The hero loops forever, and on phones that slowed down swiping the reels row further down the page.
   Also (28 Oct 2026): sets --zh-top (where the hero starts on the page, under the offer bar and header) and --zh-vh (the
   screen height) on the hero, so zed-hero-batteries.css can fit the whole banner into the first screen. On touch screens
   the height is only read again when the width changes (turning the device), so the banner doesn't jump when the
   browser's bars hide or show on scroll. */
(function () {
  if (window.ZedHeroOff) return;
  window.ZedHeroOff = true;

  var s = document.createElement('style');
  s.textContent = '.zh-hero.is-off .zh-anim,.zh-hero.is-off .zh-anim *,.zh-hero.is-off .zh-more,.zh-hero.is-off .zh-more *{animation-play-state:paused!important}';
  document.head.appendChild(s);

  var fine = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  var lastW = -1;
  function placeTop(force) {
    var w = window.innerWidth;
    var setH = force === true || fine || w !== lastW;
    lastW = w;
    document.querySelectorAll('[data-zh-hero]').forEach(function (h) {
      var t = Math.max(0, Math.round(h.getBoundingClientRect().top + window.pageYOffset)) + 'px';
      if (h.style.getPropertyValue('--zh-top') !== t) h.style.setProperty('--zh-top', t);
      if (setH && window.innerHeight > 0) h.style.setProperty('--zh-vh', window.innerHeight + 'px');
    });
  }
  var topT = 0;
  function onResize() {
    var turned = window.innerWidth !== lastW;
    if (!topT) topT = window.requestAnimationFrame(function () { topT = 0; placeTop(); });
    // iOS can report the new height a moment after the width when the device turns.
    if (turned) setTimeout(function () { placeTop(true); }, 400);
  }
  window.addEventListener('resize', onResize);
  window.addEventListener('load', function () { placeTop(); });
  document.addEventListener('shopify:section:load', function () { placeTop(true); });

  function init() {
    placeTop(true);
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.target.classList.toggle('is-off', !e.isIntersecting); });
    });
    document.querySelectorAll('[data-zh-hero]').forEach(function (h) { io.observe(h); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
